var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "glyphicons-basic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "595.281px",
    height: "419.529px",
    viewBox: "0 0 595.281 419.529",
    enableBackground: "new 0 0 595.281 419.529",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "pencil",
    fill: "#00AEEF",
    d: "M501.166,81.849l-37.176,37.177l-75.61-75.609L425.555,6.24 c6.959-6.961,18.241-6.963,25.203-0.005c0,0.003,0.003,0.004,0.003,0.005l50.404,50.406 C508.12,63.603,508.115,74.885,501.166,81.849z M156.678,275.119l75.609,75.609l206.5-206.499L363.175,68.62L156.678,275.119z  M88.785,407.487c-1.444,4.707,1.2,9.692,5.905,11.137c1.704,0.522,3.525,0.522,5.229,0l105.651-44.206l-72.583-72.581 L88.785,407.487z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.2f4980090d99290dbddc3800de5aa051.svg";
export { ForwardRef as ReactComponent };